import { api } from "services";

import { INVENTIONS_PRODUCT_KEY, AGREEMENTS_PRODUCT_KEY } from "globals/constants";

export const getAgreementProduct = async tenantId => {
	const response = await api.tenant.getTenantProducts(tenantId, 100);
	const product = response._embedded.tenant_products.find(
		product => product.active && [ INVENTIONS_PRODUCT_KEY, AGREEMENTS_PRODUCT_KEY ].includes(product.name)
	);

	return product.name;
};